/// <reference path='./global.d.ts'/>

import { createRoot } from 'react-dom/client';

import numeral from 'numeral';

import 'react-toastify/dist/ReactToastify.css';
import './Config/react-tostify.css';
import '@quero-delivery/quero-components-web/dist/index.css';
import 'rc-tooltip/assets/bootstrap.css';
import 'react-loading-skeleton/dist/skeleton.css';
import '@querodelivery/uni-react/styles.css';

import 'numeral/locales/pt-br';
import { RouterProvider } from 'react-router-dom';
import { initSentry } from './_config/lib/sentry';

import { ROUTER } from './routes';

initSentry();

numeral.locale('pt-br');

const container = document.getElementById('root');
const root = createRoot(container as Element);
root.render(<RouterProvider router={ROUTER} />);
